/* CSS spinner - https://github.com/loadingio/css-spinner */
import '../../styles/spinner.scss';

const Spinner = (props) => (
  <div className={`lds-spinner ${props.className}`}>
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Spinner;
